import React from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

export default function WizardNavigationButtons({
  prependActions = null,
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  canProceed,
}) {
  return (
    <div className="step-navigation-buttons">
      {prependActions}
      <button
        className="step-nav-btn secondary"
        onClick={onPrevious}
        disabled={currentStep === 0}
      >
        <FiArrowLeft /> Previous
      </button>
      {currentStep < totalSteps - 1 && (
        <button
          className="step-nav-btn primary"
          onClick={onNext}
          disabled={!canProceed}
        >
          Next <FiArrowRight />
        </button>
      )}
    </div>
  );
}
